import { Columns3 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ColumnIcon = createLucideIcon(Columns3);
